"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendConfiguration = void 0;
/// <reference types="node" />
const secrets_manager_1 = require("@vacasa/secrets-manager");
class BackendConfiguration {
    static idpRoles() {
        return {
            Owner: process.env["IDP_OWNER_ROLE"],
        };
    }
    static getIdpServerConfig() {
        var _a;
        return {
            domain: process.env["IDP_SERVER_DOMAIN"],
            audience: (_a = process.env["IDP_SERVER_AUDIENCE"]) === null || _a === void 0 ? void 0 : _a.split(","),
            disabled: process.env.VACASA_IDP_API_DISABLE == "true",
        };
    }
    static async getIdpClientConfig() {
        var _a, _b;
        return {
            clientId: (_a = process.env["IDP_CLIENT_ID"]) !== null && _a !== void 0 ? _a : (await this.awsSecret.getSecret("idp-app-mng-admin-web/backend/idp-mng-credentials-client-id")),
            clientSecret: (_b = process.env["IDP_SECRET_ID"]) !== null && _b !== void 0 ? _b : (await this.awsSecret.getSecret("idp-app-mng-admin-web/backend/idp-mng-credentials-secret-id")),
            url: `${BackendConfiguration.getIdpServerConfig().domain}/token`,
        };
    }
    static connectServiceConfig() {
        return { url: process.env.CONNECT_URL, audience: process.env.CONNECT_AUDIENCE, scope: ["contacts:read", "users:read"] };
    }
    static idpServiceConfig() {
        return {
            url: BackendConfiguration.getIdpServerConfig().domain,
            audience: process.env.IDP_AUDIENCE,
            scope: ["users:read", "users:write", "users:update"],
        };
    }
}
exports.BackendConfiguration = BackendConfiguration;
BackendConfiguration.awsSecret = new secrets_manager_1.SecretsManager("process.env.STAGE_ENV");
//# sourceMappingURL=backend.configuration.js.map